import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class SelectLinkBehaviour extends AbstractDataAttributeBehaviour {
    getContainerSelector() {
        return '[data-select-link]';
    }

    initContainer(container)
    {
        container.addEventListener('change', ()=> {
            window.location = container.value;
        })
    }
}